exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  background-color: #FFF;\n  color: rgba(255, 255, 255, 0.87);\n  display: block;\n  padding: 0 16px;\n}\n.navbar-app {\n  background-color: #FFF;\n}\n.navbar-app.navbar-absolute-top {\n  height: 40px;\n}\n\nh1 {\n  display: inline;\n  font-size: 20px;\n  font-weight: normal;\n  letter-spacing: 0.1px;\n  line-height: 48px;\n}\n\n.navbar-app img.navbar-img {\n  height: 32px;\n  text-align: left;\n}\n\n.navbar-app .navbar-brand {\n  padding: 0;\n}\n\n.navbar-app .navbar-brand-center img.navbar-img {\n  text-align: left;\n  margin-left: 15px;\n}\n\n.navbar-app .live-help-link,\n.navbar-app .help-link {\n  padding: 0 17px;\n}\n\n.navbar-app .navbar-brand-center,\n.navbar-app .pull-left,\n.navbar-app .pull-right {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: left;\n      -ms-flex-pack: left;\n          justify-content: left;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/utilities/toolbar/toolbar.component.css
// module id = ../../../../../src/app/utilities/toolbar/toolbar.component.css
// module chunks = main